import { Competition } from '@brg/api';
import { STATUSES } from '_competition/const';

export const isCompetitionHasFinalyst = (c: Competition<'Global'> | Competition<'Local'>) => {
  //@ts-ignore
  return (!!c?.nominations?.[0]?.finalistsID?.length || !!c?.nominations?.[0]?.winnerPositions?.length) && c?.status === STATUSES?.Completed
}import { Competition } from '@brg/api';
import { STATUSES } from '_competition/const';

export const isCompetitionHasFinalyst = (c: Competition<'Global'> | Competition<'Local'>) => {
  //@ts-ignore
  return (!!c?.nominations?.[0]?.finalistsID?.length || !!c?.nominations?.[0]?.winnerPositions?.length) && c?.status === STATUSES?.Completed
}